import { ColorPalette, ColorPaletteRoles } from "../../types/theming";
import { createPalette } from "../../functions/createPalette";

const palette: ColorPalette = {
	black: "#000000",
	white: "#FFFFFF",

	primary_accent_100: "#E8F4FE",
	primary_accent_200: "#D2E8FB",
	primary_accent_300: "#A8D1F5",
	primary_accent_400: "#6CB0ED",
	primary_accent_500: "#278AE3",
	primary_accent_600: "#0074DE",
	primary_accent_700: "#00529E",
	primary_accent_800: "#003E76",
	primary_accent_900: "#002A51",

	primary_1_100: "#F1F2F3",
	primary_1_200: "#E4E6E8",
	primary_1_300: "#C9CCD2",
	primary_1_400: "#A5AAB5",
	primary_1_500: "#6D7588",
	primary_1_600: "#303D58",
	primary_1_700: "#1D2948",
	primary_1_800: "#091535",
	primary_1_900: "#040E2F",

	secondary_1_100: "#F9F0EE",
	secondary_1_200: "#F9E1DC",
	secondary_1_300: "#FBBDB0",
	secondary_1_400: "#FA8B75",
	secondary_1_500: "#E9553C",
	secondary_1_600: "#D63D27",
	secondary_1_700: "#992A1A",
	secondary_1_800: "#6E2418",
	secondary_1_900: "#4A1C14",

	secondary_2_100: "#EFF3F6",
	secondary_2_200: "#DDE6ED",
	secondary_2_300: "#B9D0DF",
	secondary_2_400: "#81B0CF",
	secondary_2_500: "#408EBD",
	secondary_2_600: "#1B7CAE",
	secondary_2_700: "#10577C",
	secondary_2_800: "#174059",
	secondary_2_900: "#162C3B",

	secondary_3_100: "#F0F2F3",
	secondary_3_200: "#E3E6E8",
	secondary_3_300: "#C7CDD3",
	secondary_3_400: "#A0ACB6",
	secondary_3_500: "#788999",
	secondary_3_600: "#647789",
	secondary_3_700: "#415467",
	secondary_3_800: "#303E4D",
	secondary_3_900: "#222B35",

	neutral_100: "#F1F2F3",
	neutral_200: "#E4E6E8",
	neutral_300: "#C9CCD2",
	neutral_400: "#A5AAB5",
	neutral_500: "#808797",
	neutral_600: "#6D7588",
	neutral_700: "#47526B",
	neutral_800: "#303D58",
	neutral_900: "#1D2948",
	neutral_1000: "#091535",
	neutral_1100: "#040E2F",

	semantic_error_100: "#F9F0EE",
	semantic_error_200: "#F9E1DC",
	semantic_error_300: "#FBBDB0",
	semantic_error_400: "#FA8B75",
	semantic_error_500: "#E9553C",
	semantic_error_600: "#D63D27",
	semantic_error_700: "#992A1A",
	semantic_error_800: "#6E2418",
	semantic_error_900: "#4A1C14",

	semantic_info_100: "#E8F4FE",
	semantic_info_200: "#D2E8FB",
	semantic_info_300: "#A8D1F5",
	semantic_info_400: "#6CB0ED",
	semantic_info_500: "#278AE3",
	semantic_info_600: "#0074DE",
	semantic_info_700: "#00529E",
	semantic_info_800: "#003E76",
	semantic_info_900: "#002A51",

	semantic_success_100: "#E5F7E6",
	semantic_success_200: "#C4F1C5",
	semantic_success_300: "#72E37E",
	semantic_success_400: "#00C445",
	semantic_success_500: "#069C35",
	semantic_success_600: "#1A8732",
	semantic_success_700: "#245D2A",
	semantic_success_800: "#214423",
	semantic_success_900: "#1B2F1B",

	semantic_warning_100: "#FEF0DB",
	semantic_warning_200: "#FFE1B4",
	semantic_warning_300: "#FFC163",
	semantic_warning_400: "#EE9609",
	semantic_warning_500: "#BE7704",
	semantic_warning_600: "#A3670F",
	semantic_warning_700: "#704A18",
	semantic_warning_800: "#513817",
	semantic_warning_900: "#372714",

	tertiary_1_100: "#FFFBDE",
	tertiary_1_200: "#FFF4A3",
	tertiary_1_300: "#FFE55E",
	tertiary_1_400: "#FCC500",
	tertiary_1_500: "#D3A300",
	tertiary_1_600: "#A68214",
	tertiary_1_700: "#8F711A",
	tertiary_1_800: "#62501E",
	tertiary_1_900: "#473C1B",

	tertiary_2_100: "#FDFBF7",
	tertiary_2_200: "#F8F2E2",
	tertiary_2_300: "#F1E6C5",
	tertiary_2_400: "#E1CB87",
	tertiary_2_500: "#C6A748",
	tertiary_2_600: "#9D8439",
	tertiary_2_700: "#887332",
	tertiary_2_800: "#605123",
	tertiary_2_900: "#473C1A",
};

const rolesPalette: ColorPaletteRoles = {
	bg_dark: "primary_1_900",
	bg_dark_variant: "primary_1_700",
	bg_light: "primary_accent_100",
	bg_light_variant: "primary_1_100",
	bg_white: "white",

	fg_dark_1: "neutral_900",
	fg_dark_2: "neutral_800",
	fg_dark_3: "neutral_700",
	fg_light_1: "white",
	fg_light_2: "neutral_200",
	fg_light_3: "neutral_300",

	cta_active: "primary_accent_700",
	cta_default: "primary_accent_600",
	cta_disabled: "primary_1_200",
	cta_focus: "primary_accent_400",
	cta_hover: "primary_accent_400",
};

const paletteInstance = createPalette(palette, rolesPalette);
export { paletteInstance as palette };
